import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=3e81422a&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=3e81422a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e81422a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e81422a')) {
      api.createRecord('3e81422a', component.options)
    } else {
      api.reload('3e81422a', component.options)
    }
    module.hot.accept("./NotificationList.vue?vue&type=template&id=3e81422a&scoped=true", function () {
      api.rerender('3e81422a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/NotificationList.vue"
export default component.exports